import { useSettings } from "../../../../context";
import { AVAILABLE_FILTERS } from "../../../../context/utils/filters";
import FilterControl from "./control";
import { AccordionWrapper, ContentWrapper, SettingsAccordion } from "./styled";

const Filters = () => {
  const { getSelectedItemSettings } = useSettings();

  const currentSettings = getSelectedItemSettings();

  if (currentSettings?.type !== "video") {
    return null;
  }

  const appliedFilters = currentSettings.configuration.filters;

  return (
    <ContentWrapper>
      <AccordionWrapper>
        <SettingsAccordion defaultActiveKey={[]}>
          {AVAILABLE_FILTERS.map((filterConfig) => {
            const appliedFilter = appliedFilters.find(
              (f) => f.type === filterConfig.value
            );

            const currentValue = appliedFilter
              ? appliedFilter.value
              : filterConfig.defaultValue;

            return (
              <FilterControl
                key={filterConfig.value}
                config={filterConfig}
                currentValue={currentValue}
              />
            );
          })}
        </SettingsAccordion>
      </AccordionWrapper>
    </ContentWrapper>
  );
};

export default Filters;
